import Model from 'core/model/Model';
import $devices from 'app/stores/device/$devices';
import { computed } from 'mobx';
import { Capabilities } from '@kentik/ui-shared/agents/constants';

export const GroupRank = {
  NEW_AGENT: -1,
  SOLO_AGENT: 0,
  DEFAULT: 1,
  CLUSTER_AGENT: 2
};

const GroupRankLabels = {
  [GroupRank.NEW_AGENT]: 'New Agents',
  [GroupRank.SOLO_AGENT]: 'Agents',
  [GroupRank.DEFAULT]: 'Agents',
  [GroupRank.CLUSTER_AGENT]: 'Clustered Agents'
};

class KentikAgentModel extends Model {
  get urlRoot() {
    return '/api/ui/kentik-agent/agents';
  }

  @computed
  get isRangerEnabled() {
    return !!this.get('capabilities')?.find((capability) => capability.name === 'ranger' && capability.running);
  }

  @computed
  get closestDevice() {
    const closest_device_id = this.get('closest_device_id');
    return $devices.deviceSummaries.find((device) => parseInt(device.id) === closest_device_id);
  }

  @computed
  get hasClusterId() {
    return !!this.get('cluster_id');
  }

  @computed
  get clusterName() {
    return this.get('clusterName');
  }

  @computed
  get groupRank() {
    if (this.get('configured') === undefined) {
      return GroupRank.DEFAULT;
    }

    switch (this.get('configured')) {
      case false:
        return GroupRank.NEW_AGENT;
      case true:
        if (this.hasClusterId) {
          return GroupRank.CLUSTER_AGENT + this.get('cluster_id');
        }
        return GroupRank.SOLO_AGENT;
      default:
        return GroupRank.DEFAULT;
    }
  }

  static formatGroupLabel(rank) {
    if (rank > GroupRank.CLUSTER_AGENT) {
      return 'Clustered Agents';
    }
    return GroupRankLabels[rank] || `Unknown Agents ${rank}`;
  }

  @computed
  get name() {
    return this.get('display_name') || this.get('host_name');
  }

  @computed
  get synthAgent() {
    if (this.getCapability(Capabilities.KSYNTH)) {
      return this.store.$syn.agents.get().find((synthAgent) => synthAgent.get('metadata.ua_id') === this.id);
    }

    return null;
  }

  getCapability(capabilityName) {
    return this.get('capabilities')?.find((capability) => capability.name === capabilityName);
  }

  deserialize(data) {
    const deserialized = { ...data, id: data.agent_id };
    if (data.site_id) {
      deserialized.site = { id: data.site_id };
    }

    return deserialized;
  }
}

export default KentikAgentModel;
